
export class AppUtils {

    downloadFile(data, fileName: string, type: string): void {
        const blob = new Blob([data], { type });

        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = fileName;
        link.click();
    }

    flattenTree(nodes: any[]): any[] {
        const result: any[] = [];

        const traverse = (nodeList: any[]) => {
            for (const node of nodeList) {
                result.push(node);
                if (node.children && node.children.length > 0) {
                    traverse(node.children);
                }
            }
        };

        traverse(nodes);
        return result;
    }

    /**
 * Update checked state of a node in the tree (by id) and its descendants,
 * and updates ancestors' indeterminate state.
 */
    updateCheckedStateInTree(
        tree: any[],
        targetId: number,
        checked: boolean
    ): any[] {
        // Helper: recursively update children and return new list
        function updateNode(node: any): [any, boolean] {
            let descendantsCheckedCount = 0;
            let updatedChildren: any[] = [];

            if (node.children && node.children.length > 0) {
                updatedChildren = node.children.map(child => {
                    const [updatedChild, childChanged] = updateNode(child);
                    if (updatedChild.checked) descendantsCheckedCount++;
                    return updatedChild;
                });
            }

            // If this is the selected node, override checked
            let isChecked = node.id === targetId ? checked : node.checked ?? false;

            // Determine new checked/indeterminate state
            if (updatedChildren.length > 0) {
                const allChildrenChecked = updatedChildren.every(child => child.checked);
                const someChecked = updatedChildren.some(child => child.checked || child.indeterminate);
                isChecked = allChildrenChecked;
                node.indeterminate = !allChildrenChecked && someChecked;
            } else {
                node.indeterminate = false;
            }

            return [{
                ...node,
                checked: node.id === targetId ? checked : isChecked,
                indeterminate: node.indeterminate,
                children: updatedChildren.length > 0 ? updatedChildren : null
            }, true];
        }

        // Update each top-level node
        return tree.map(node => updateNode(node)[0]);
    };

    /**
 * Recursively filters out nodes from baseTree whose IDs are found in nodesToRemove.
 * Collects IDs from all levels of nodesToRemove (handles tree-structured assigned screens).
 * When a parent is excluded but some of its children are NOT excluded (because the backend
 * returned the parent with children:null even though those children are not assigned),
 * those children are promoted up to the parent's position so they remain visible.
 */
filterTreeByExclusion(baseTree: any[], nodesToRemove: any[]): any[] {
  // Collect all IDs recursively from nodesToRemove (only what was actually assigned)
  const collectAllIds = (nodes: any[]): Set<number> => {
    const ids = new Set<number>();
    const traverse = (nodeList: any[]) => {
      for (const node of nodeList) {
        ids.add(node.id);
        if (node.children && node.children.length > 0) {
          traverse(node.children);
        }
      }
    };
    traverse(nodes);
    return ids;
  };

  const idsToRemove = collectAllIds(nodesToRemove);

  const filterRecursive = (nodes: any[]): any[] => {
    const result: any[] = [];
    for (const node of nodes) {
      if (idsToRemove.has(node.id)) {
        // This node is assigned — exclude it, but promote any non-excluded children
        // (e.g. parent was assigned with children:null, but some children are not assigned)
        if (node.children && node.children.length > 0) {
          const promotedChildren = filterRecursive(node.children);
          result.push(...promotedChildren);
        }
      } else {
        const filteredChildren = node.children ? filterRecursive(node.children) : null;
        result.push({
          ...node,
          children: filteredChildren && filteredChildren.length > 0 ? filteredChildren : null
        });
      }
    }
    return result;
  };

  return filterRecursive(baseTree);
}


    // uniq array
    uniqArray = (list: any[]): any[] => {
        return list.filter((obj, index, self) =>
            index === self.findIndex((screen) => screen.id === obj.id)
        );
    };
}